import { isCourseMainPage } from "../../../helpers/getIsCourseMainPage";
import { CreateLinkTo, LinkTo } from "../../../constants/linkTo";
import { useLocation, useRouteMatch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useProject } from "../../../hooks/api/useProject";
import i18next from "i18next";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";
import { CourseWithTooltip } from "../components/CourseWidthTooltip";
import { getFriendlyUrlParamId } from "shared/hooks/useGetFriendlyUrlParam";
import useAppTester from "shared/MobileMenu/hooks/useAppTester";
import { useBreakpoint } from "@brg/ui";

export const useGetMyCoursesTabs = () => {
    const location = useLocation();
    const is1700 = useBreakpoint(1750);
    const { t } = useTranslation();
    const projectPage = useRouteMatch<{ id: string }>("/project/:id");
    //@ts-ignore
    const id = getFriendlyUrlParamId(projectPage?.params?.id);

    const {
       isLMSHSE,
       isLMSHSECreative,
    } = useAppTester();

    const isCoursesPersonalPage = location.pathname?.startsWith('/courses/profile')

    const needLMSTabs = isLMSHSE || isLMSHSECreative || isCoursesPersonalPage;

    const [projectSource] = useProject(id, i18next.language, id, !needLMSTabs);

    return {
        [NAVBAR_TAB_NAMES.my_courses]: {
            active: isCourseMainPage(location),
            content: t("nav.my_courses"),
            linkTo: LinkTo.myCourses,
        },
        [NAVBAR_TAB_NAMES.schedule]: {
            content: t("nav.schedule"),
            linkTo: LinkTo.myCoursesSchedule,
        },
        [NAVBAR_TAB_NAMES.homework]: {
            content: t("nav.homework"),
            linkTo: LinkTo.myCoursesHomework,
        },
        [NAVBAR_TAB_NAMES.grades]: {
            content: t("nav.grades"),
            linkTo: LinkTo.myCoursesGrades,
        },
        // @ts-ignore
        ...(id && projectSource?.teams?.[0]?.teamId ? {
            [NAVBAR_TAB_NAMES.project_module_name]: {
                active: location.pathname === LinkTo.myCourses,
                disabled: false,
                content: is1700 ? projectSource?.teams?.[0]?.name || '' : <CourseWithTooltip courseName={projectSource?.teams?.[0]?.name || ''} />,
                linkTo: CreateLinkTo.course(projectSource?.teams?.[0]?.teamId || '')
            }
        } : {})
    }
}


import { isCourseMainPage } from "../../../helpers/getIsCourseMainPage";
import { CreateLinkTo, LinkTo } from "../../../constants/linkTo";
import { useLocation, useRouteMatch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useProject } from "../../../hooks/api/useProject";
import i18next from "i18next";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";
import { CourseWithTooltip } from "../components/CourseWidthTooltip";
import { getFriendlyUrlParamId } from "shared/hooks/useGetFriendlyUrlParam";
import useAppTester from "shared/MobileMenu/hooks/useAppTester";
import { useBreakpoint } from "@brg/ui";

export const useGetMyCoursesTabs = () => {
    const location = useLocation();
    const is1700 = useBreakpoint(1750);
    const { t } = useTranslation();
    const projectPage = useRouteMatch<{ id: string }>("/project/:id");
    //@ts-ignore
    const id = getFriendlyUrlParamId(projectPage?.params?.id);

    const {
       isLMSHSE,
       isLMSHSECreative,
    } = useAppTester();

    const isCoursesPersonalPage = location.pathname?.startsWith('/courses/profile')

    const needLMSTabs = isLMSHSE || isLMSHSECreative || isCoursesPersonalPage;

    const [projectSource] = useProject(id, i18next.language, id, !needLMSTabs);

    return {
        [NAVBAR_TAB_NAMES.my_courses]: {
            active: isCourseMainPage(location),
            content: t("nav.my_courses"),
            linkTo: LinkTo.myCourses,
        },
        [NAVBAR_TAB_NAMES.schedule]: {
            content: t("nav.schedule"),
            linkTo: LinkTo.myCoursesSchedule,
        },
        [NAVBAR_TAB_NAMES.homework]: {
            content: t("nav.homework"),
            linkTo: LinkTo.myCoursesHomework,
        },
        [NAVBAR_TAB_NAMES.grades]: {
            content: t("nav.grades"),
            linkTo: LinkTo.myCoursesGrades,
        },
        // @ts-ignore
        ...(id && projectSource?.teams?.[0]?.teamId ? {
            [NAVBAR_TAB_NAMES.project_module_name]: {
                active: location.pathname === LinkTo.myCourses,
                disabled: false,
                content: is1700 ? projectSource?.teams?.[0]?.name || '' : <CourseWithTooltip courseName={projectSource?.teams?.[0]?.name || ''} />,
                linkTo: CreateLinkTo.course(projectSource?.teams?.[0]?.teamId || '')
            }
        } : {})
    }
}


